export default __webpack_public_path__ + "media/images/projekktor-maccaco/buffering-017a673b9da52409ed00ce34313e971b.gif";